export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/de.lyaml"));
vm(require("foundations-components/lang/de.lyaml"));
vm(require("feature-monetization/lang/de.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/de.lyaml"));
vm(require("usage-based-billing-components-lib/lang/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/header/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/marketing-hub/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-copy/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-price/de.lyaml"));
vm(require("pricing-pages-ui-public-app/lang/merch-card-term/de.lyaml"));
at({ "de": { "ui": { "UILoadingSpinner": { "busyText": "Wird geladen", "completedText": "Ladevorgang abgeschlossen" } }, "publicPricingPage": { "windowTitles": { "default": "Preise | HubSpot" } } } });
};